import styled from '@emotion/styled'

export const StyleRefWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 30%;
  @media (max-width: 1300px) {
    flex-basis: 45%;
  }
  @media (max-width: 1024px) {
    flex-basis: 50%;
  }
  @media (max-width: 500px) {
    flex-basis: 60%;
  }
`
